import React from 'react';
import { Link } from 'react-router-dom';
import Newsheader from './headers/headerfornews';
import NewsCarousel from './whatisnew/NewsCarousel';
import './whatisnew/NewsCarousel.css';

/**
 * Full News & Highlights list — destination for sidebar "See more".
 */
export default function NewsListPage({ user }) {
  return (
    <div className="news-list-page">
      <Newsheader />
      <div className="news-list-page__inner">
        <Link to="/home" className="news-back-link">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M15 6l-6 6 6 6" />
          </svg>
          Back to home
        </Link>
        <NewsCarousel user={user} showViewAll={false} />
      </div>
    </div>
  );
}
